export default __webpack_public_path__ + "static/media/about-work-details.4f6d5cb5.png";